
// Add more keys like 'Key1' | 'Key2' | 'key3'
export type StorageKey = 'SELECTED_COMPANY_ID';

// Why `x | Promise<x>` amd `Promise.resolve()`?
// React Native Storage returns promise, Web `window.locatStorage` doesn't
// So, we normalize the output to work with both
export interface IStorage {
    getItem(key: string): string | Promise<string>;
    setItem(key: string, value: string): void | Promise<void>;
    removeItem(key: string): void | Promise<void>;
}

const storage = {
    _internalStorage: null as IStorage,
    get instance(): IStorage {
        if (!this._internalStorage) {
            throw new Error(`
Cann't use storage methods before initializing storage backend store.
Call \`initStorage()\` with React Native \`AsyncStorage\` or web \`window.localStorage\` before use.`);
        }
        return this._internalStorage;
    }
};

export function init(storageInstance: IStorage) {
    if (!storageInstance) {
        throw new Error('Invald `storageInstance` object');
    }
    storage._internalStorage = storageInstance;
}

export function getItem(key: StorageKey) {
    return Promise.resolve()
        .then(() => storage.instance.getItem(key))
        .catch<string>(() => null);
}

export function setItem(key: StorageKey, value: string) {
    return Promise.resolve<void>(storage.instance.setItem(key, value));
}

export function removeItem(key: StorageKey) {
    return Promise.resolve<void>(storage.instance.removeItem(key));
}
